import React from "react"
import { FormattedMessage, FormattedNumber } from "react-intl"
import {
	DEPARTMENT_MARKET_TITLE,
	formatProps,
	NEGATIVE,
	POSITIVE,
} from "components/Shared/GenerateGrowthNode/constants"

interface FormatPercentageProps {
	value: number
	description: string
	label?: string
	showAsPoints?: boolean
}

interface PercentageAmountProps {
	arrow: string
	color: string
	description: string
	value: number
	showAsPoints?: boolean
	label?: string
}

const PercentageAmount: React.FC<PercentageAmountProps> = ({
	arrow,
	color,
	description,
	value,
	showAsPoints,
	label,
}) => {
	let percentageValue = value
	let points = ""
	let percentageStyle: "percent" | "decimal" = "percent"

	if (showAsPoints) {
		percentageStyle = "decimal"
		points = "pts"
		percentageValue = value * 100
	}

	return (
		<div className="percentage font-20">
			<img src={arrow} alt="arrow-indicator" width="16px" />{" "}
			<p className={color}>
				<FormattedMessage
					id={description}
					values={{
						percentage: (
							<FormattedNumber
								value={percentageValue}
								style={percentageStyle}
								minimumFractionDigits={2}
								maximumFractionDigits={2}
							/>
						),
						market: <FormattedMessage id={label || DEPARTMENT_MARKET_TITLE} />,
						points,
					}}
				/>
			</p>
		</div>
	)
}

export const FormatPercentage: React.FC<FormatPercentageProps> = (props) => (
	<React.Fragment>
		{props.value?.toString() !== "" && (
			<PercentageAmount
				{...formatProps[props.value < 0 ? NEGATIVE : POSITIVE]}
				{...props}
			/>
		)}
	</React.Fragment>
)
